import axios from "axios";
const UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
const IMAGE_UPLOAD_URL = process.env.REACT_APP_CLOUDINARY_IMAGE_UPLOAD_URL;

const uploadToCloudinary = async (file) => {
  if (!file) return null;

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", UPLOAD_PRESET);

  try {
    const res = await axios.post(IMAGE_UPLOAD_URL, formData);
    return res.data.secure_url;
  } catch (err) {
    console.error("Cloudinary upload failed:", err);
    throw new Error("Cloudinary upload failed");
  }
};
export default uploadToCloudinary;
